import { Box, Typography } from '@mui/material';
import { useEffect } from 'react';
import useDrawRadial from '../../hooks/useDrawRadial';
import { StatusPossessionType } from '../../types/PurposeType';
import BigNumber from 'bignumber.js';
import { cutCommas } from '../../lib/Bignumbers';

const CustomRadialChart = ({ possession }: { possession: StatusPossessionType }) => {
  const { remainingAmount: remain, unlockUmount: unlock, amount } = possession;
  const unlockAmount = BigNumber(cutCommas(unlock)).dividedBy(cutCommas(amount)).multipliedBy(100).toFixed(1, 1);
  const remainingAmount = BigNumber(cutCommas(remain)).dividedBy(cutCommas(amount)).multipliedBy(100).toFixed(1, 1);

  const { canvas, drawChart, formattedPercentage } = useDrawRadial(Number(remainingAmount));

  useEffect(() => {
    drawChart();
  }, [drawChart]);

  return (
    <Box sx={{ mx: 'auto' }}>
      <Box sx={{ width: '150px', height: '150px', mx: 'auto' }}>
        <canvas ref={canvas}></canvas>
      </Box>
      <Box
        sx={{
          display: 'flex',
          gap: { xs: '11px', md: '6px' },
          flexDirection: 'column',
          pl: '17px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: '7px',
            flexWrap: 'wrap',
            flexDirection: { xs: 'column', md: 'row' },
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
            <Box
              sx={{
                width: '8px',
                height: '8px',
                borderRadius: 100,
                background: '#661EFF',
              }}
            />
            <Typography
              sx={{
                fontSize: { xs: '11px', md: '12px' },
                lineHeight: '18px',
                letterSpacing: '-0.02em',
                color: '#A5A5A5',
                width: '100px',
              }}
            >
              UnLock Amount
            </Typography>
          </Box>
          <Typography
            sx={{
              fontSize: { xs: '14px', md: '16px' },
              lineHeight: { xs: '18px', md: '19px' },
              letterSpacing: '0',
              color: '#333333',
              fontWeight: '500',
            }}
          >
            {formattedPercentage(Number(unlockAmount))}%
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            gap: '7px',
            flexWrap: 'wrap',
            flexDirection: { xs: 'column', md: 'row' },
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
            <Box
              sx={{
                width: '8px',
                height: '8px',
                borderRadius: 100,
                background: '#64CFF6',
              }}
            />
            <Typography
              sx={{
                fontSize: { xs: '11px', md: '12px' },
                lineHeight: '18px',
                letterSpacing: '-0.02em',
                color: '#A5A5A5',
                width: '100px',
              }}
            >
              Remaining Amount
            </Typography>
          </Box>
          <Typography
            sx={{
              fontSize: { xs: '14px', md: '16px' },
              lineHeight: { xs: '18px', md: '19px' },
              letterSpacing: '0',
              color: '#333333',
              fontWeight: '500',
            }}
          >
            {formattedPercentage(Number(remainingAmount))}%
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default CustomRadialChart;
